import { useState, useEffect } from "react";

/**
 * Returns `true` when the document is visible, `false` when hidden.
 * Components/hooks that run timers or hold open network connections
 * should pause when this returns `false` to save battery.
 */
export function useDocumentVisible(): boolean {
  const [visible, setVisible] = useState(!document.hidden);

  useEffect(() => {
    const handler = () => setVisible(!document.hidden);
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }, []);

  return visible;
}
